var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GrootHeroBanner',{attrs:{"title":"Begäran om tillträde till Skanovas fysiska infrastruktur","breadcrumbs":_vm.breadcrumbItems}}),_c('div',{staticClass:"form-container"},[(_vm.html)?_c(_vm.form,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }